__turbopack_context__.v({
  "fadeGlyph": "j-k3fG_fadeGlyph",
  "logo": "j-k3fG_logo",
  "mark": "j-k3fG_mark",
  "markBar": "j-k3fG_markBar",
  "markDot": "j-k3fG_markDot",
  "svg": "j-k3fG_svg",
  "wGlyph": "j-k3fG_wGlyph",
});
